
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sponsorships",
      function () {
        return require("private-next-pages/sponsorships/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sponsorships"])
      });
    }
  